import {Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter} from "@angular/core";

declare var Cropper: any;

@Component({
    selector: 'image-editor',
    template: require('./image-editor.component.pug'),
    styles: [require('./image-editor.component.css')]
})
export class ImageEditorComponent implements OnInit {
    @ViewChild('imageEditor') imageEditor: ElementRef;

    @Input() cropperOptions = {
        aspectRatio: 1,
        movable: true,
        scalable: true,
        zoomable: true,
        viewMode: 3,
        checkCrossOrigin: true
    };
    @Input() image: any;
    @Input() type: string = 'image/jpeg';
    @Input() encoderOptions: number = 1;

    @Output() export = new EventEmitter(); 
    @Output() ready = new EventEmitter(); 

    cropper: any;

    constructor() {
    }

    ngOnInit(): void {
    }

    imageLoad(): void {
        this.cropper = new Cropper(this.imageEditor.nativeElement, this.cropperOptions);
    }

    setDragMode(mode: string): void {
        this.cropper.setDragMode(mode);
    }

    zoom(factor: number): void {
        this.cropper.zoom(factor);
    }

    move(x: number, y: number): void {
        this.cropper.move(x, y);
    }

    rotate(grades: number) {
        this.cropper.rotate(grades);
    }

    scaleX() {
        let data = this.cropper.getImageData();
        this.cropper.scaleX((data.scaleX === -1 ) ? 1 : -1);
    }

    scaleY() {
        let data = this.cropper.getImageData();
        this.cropper.scaleY((data.scaleY === -1 ) ? 1 : -1);
    }

    crop(): void {
        this.cropper.getCroppedCanvas().toBlob((blob: any) => {
            let data = this.cropper.getCropBoxData();
            this.export.emit({data: data, blob: blob});
        }, this.type, this.encoderOptions);
    }

    clear(): void {
        this.cropper.clear();
    }

    reset(): void {
        this.cropper.reset();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/image-editor/image-editor.component.ts